import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import { Observable } from 'rxjs';

export class AvsMarketDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.AVS_MARKETS, apiHelper);
    }

    getAllForCustomer(): Observable<any> {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/get/customer';
        return this.apiHelper.get(url, null, null);
    }
}
